import * as React from "react";
import { Link } from 'gatsby-plugin-material-ui';
import { kebabCase } from "lodash";

import { styled } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import BlogChip from './BlogChip';

const NavButton = (props) => {
  console.log(props);
  return (
    <Button
      component={Link}
      variant="outlined"
      size="small"
      sx={{
        fontSize: '0.8em',
        fontWeight: 'normal',
        textTransform: 'none',
        borderRadius: '1em',
        paddingTop: 0,
        paddingBottom: 0,
        minWidth: 0
      }}
      {...props}
  />);
};

export default function BlogNavigation({ doc, articles }) {
  return (
    <>
      <Toolbar variant="dense" disableGutters aria-label="Article tags." sx={{flexWrap: "wrap"}}>
        <TagList tags={doc.frontmatter.tags} date={doc.frontmatter.date}/>
      </Toolbar>
      <Toolbar variant="dense" disableGutters aria-label="Blog navigation.">
        <Box sx={{flexGrow: 1}}>
          <NavButton>← Prev</NavButton>
        </Box>
        <Box sx={{flexGrow: 1, textAlign: "right"}}>
          <NavButton>Next →</NavButton>
        </Box>
      </Toolbar>
    </>
  );
}

export function TagList({ tags, date, all }) {
  return (
    <>
      {
        all && <BlogChip to="/brewlog/articles" label='All' color="secondary" />
      }
      {(tags.length &&
        tags.map(tag => (
          <NavButton
            key={tag}
            to={`/brewlog/tags/${kebabCase(tag)}`}
          >
            {tag}
          </NavButton>
        )
      ))}
      {
        date && <NavButton color="secondary">{date}</NavButton>
      }
    </>
  );
}

/*
function BlogTag({ tags })

export BlogTag;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

function ButtonAppBar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            News
          </Typography>
          <Button color="inherit">Login</Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
*/